import {Body} from 'shells/typography/body';

interface Props {
    children: React.ReactNode;
}

export function SectionHeader(props: Props) {
    return (
        <div className='flex align-center py-4 px-12 gap-6'>
            <Body size='small' color='light' isBold={true}>
                {props.children}
            </Body>
        </div>
    );
}
